import { UfpbChalkboardTeacher, UfpbUserPC } from '../icons';

import { FaUserGraduate } from 'react-icons/fa';
import { TipoGrupoEleitoresEnumType } from '../types/enums/TipoGrupoEleitoresEnumType';

const TipoGrupoEleitoresEnum: { [key: string]: any } = Object.freeze({
  DISCENTE: {
    descricao: 'label.eleitores_discentes',
    icon: FaUserGraduate,
    key: 'DISCENTE',
  },
  DOCENTE: {
    descricao: 'label.eleitores_docentes',
    equivalencia: 'DOCENTE_EXTERNO',
    icon: UfpbChalkboardTeacher,
    key: 'DOCENTE',
  },
  DOCENTE_EXTERNO: {
    descricao: 'label.eleitores_docentes',
    equivalencia: 'DOCENTE',
    icon: UfpbChalkboardTeacher,
    key: 'DOCENTE_EXTERNO',
  },
  TECNICO_ADMINISTRATIVO: {
    descricao: 'label.eleitores_tecnico_administrativos',
    icon: UfpbUserPC,
    key: 'TECNICO_ADMINISTRATIVO',
  },
  findByKey: (key: string) => {
    let objFound = TipoGrupoEleitoresEnum.getAll().find((obj: TipoGrupoEleitoresEnumType) => obj.key === key);
    if (objFound) {
      return objFound;
    }
    throw Error(`Chave ${key} não foi encontrada na enum.`);
  },
  getAll: () =>
    Object.keys(TipoGrupoEleitoresEnum)
      .filter((genericProperty) => typeof TipoGrupoEleitoresEnum[genericProperty] === 'object')
      .map((indexFound) => TipoGrupoEleitoresEnum[indexFound]),
});

export default TipoGrupoEleitoresEnum;
